import { Button, Spinner, Modal } from "react-bootstrap";
import { useState, useEffect, useRef } from "react";
import LoginImg from "../image/retailCalculatorLogin.png";
import LoginImgMobile from "../image/Logo_Original.png";
import config, {
  mobileNumberLimit,
  otpLength,
  otpDuration,
} from "../../config";
import { Auth } from "aws-amplify";
import { useDispatch } from "react-redux";
import { withRouter } from "../../utils/withRouter";
import { v4 as uuidv4 } from "uuid";
import { useSelector } from "react-redux";
import PhoneInput from "react-phone-input-2";
import CountryJSON from "../../countries.json";
import "../../phoneInput.css";
import { postcodeValidator } from "postcode-validator";
import ReCAPTCHA from "react-google-recaptcha";
import { Form, Typography, theme } from "antd";
import { useSetAccess } from "../../provider/AccessProvider";
import { usePushNotification } from "../../hooks/usePushNotification";
const Login = (props) => {
  const dispatch = useDispatch();
  const requestPushNotification = usePushNotification();
  const captchaRef = useRef(null);
  const {
    token: { colorPrimary },
  } = theme.useToken();
  const [phoneNumber, setPhoneNumber] = useState("");
  // const [minutes, setMinutes] = useState("");
  // const [seconds, setSeconds] = useState("");
  const [otp, setOtp] = useState("");
  const [otpInput, setOtpInput] = useState(false);
  const [resendOtpFlag, setResendOtpFlag] = useState(false);
  const [loading, setLoading] = useState(false);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [user, setUser] = useState({});
  const [userSignUp, setUserSignUp] = useState(false);
  const [shopId, setShopId] = useState("");
  const [shopName, setShopName] = useState("");
  const [shopAddress, setShopAddress] = useState("");
  const [shopPincode, setShopPincode] = useState("");
  const [shopType, setShopType] = useState("");
  const [referralCode, setReferralCode] = useState("");
  const [tAndC, setTandC] = useState([]);
  const [tAndCModal, setTandCModal] = useState(false);
  const [shopTypeArray, setShopTypeArray] = useState([]);
  const [from, setFrom] = useState("login");
  const [userType, setUserType] = useState("owner");
  const [outletList, setOutletList] = useState([]);
  const shopDetails = useSelector((state) => state.shopDetails);
  const [dialCode, setDialCode] = useState("");
  const [countryCode, setCountryCode] = useState("IN");
  const [countryData, setCountryData] = useState({});
  const _phoneNumber = phoneNumber.slice(dialCode.length, phoneNumber.length);
  const defaultDialCode = window.location.hostname.split(".")[2];
  const [, setAccess] = useSetAccess();
  const verifyNumber = async (e) => {
    if (_phoneNumber === "") {
      alert("Enter phone number");
      return;
    }
    if (_phoneNumber.length !== CountryJSON[`+${dialCode}`]?.numberLimit) {
      alert("Enter valid phone number");
      return;
    }
    // const token = captchaRef.current.getValue();
    // let verifyBot = false;
    // if (!token) {
    //   return alert("You must confirm you are not a robot");
    // } else {
    //   const response = await verifyToken(token);
    //   verifyBot = response.success;
    // }
    // if (verifyBot) {
    setLoading(true);
    loginProcess();
    // } else {
    //   return alert("Login failed, Reload and try again!");
    // }
  };
  const loginProcess = async () => {
    await Auth.signIn("+" + phoneNumber)
      .then((response) => {
        if (response.challengeName === "CUSTOM_CHALLENGE") {
          setLoading(false);
          setOtpInput(true);
          setUserSignUp(false);
          setUser(response);
          if (resendOtpFlag) {
            setResendOtpFlag(false);
            alert("New OTP has been sent to your number");
          }
        }
      })
      .catch((err) => {
        if (err.code === "NetworkError") {
          setLoading(false);
          return alert("Please check your network connection and try again");
        }
        if (err.code === "UserNotFoundException") {
          if (userType === "employee") {
            alert("Account not found. Please contact your shop owner.");
            setLoading(false);
            setConfirmLoading(false);
            return;
          }
          alert("Account not found. Please Sign up.");
          setLoading(false);
          setConfirmLoading(false);
          setUserSignUp(true);
          setFrom("signup");
        }
      });
  };

  // const otpTimer = () => {
  //   var timer = otpDuration,
  //     minutes,
  //     seconds;

  //   var interval = setInterval(() => {
  //     minutes = parseInt(timer / 60, 10);
  //     seconds = parseInt(timer % 60, 10);

  //     minutes = minutes < 10 ? "0" + minutes : minutes;
  //     seconds = seconds < 10 ? "0" + seconds : seconds;

  //     setMinutes(minutes);
  //     setSeconds(seconds);

  //     if (--timer < 0) {
  //       setResendOtpFlag(true);
  //       clearInterval(interval);
  //     }
  //   }, 1000);
  // };

  // useEffect( ()=>{

  //   if(shopDetails.shopType !== "Restaurant"){
  //    if(shopDetails.shopId){
  //      fetch(`${config.ApiGateway1}/customBillsettings`,
  //      {
  //        headers: {
  //          "Content-Type": "application/json",

  //        },
  //        body:JSON.stringify({shopId:shopDetails.shopId  ,type:"update"}),
  //        method: "POST",
  //      }
  //    )
  //    .then((res) => res.json())
  //    .then((data) => {
  //        console.log("settings data=====",data)
  //          // const Check boxdata= JSON.parse(data)
  //          console.log("Checkboxdata------",data)
  //           let Checkboxdata=data.newBillsettings;
  //          let UpdateCheckbox = {};
  //          for(let i = 0; i < Checkboxdata.length; i++ ) {
  //              Object.assign(UpdateCheckbox, Checkboxdata[i]);
  //            }

  //            console.log("\nAfter converting  Billing_______----",UpdateCheckbox);
  //            dispatch({
  //              type: "INVOICE-NEWBILLSETTINGS",
  //              payload: UpdateCheckbox,
  //            });

  //          return Checkboxdata;
  //        })

  //    }
  //  }

  //    },[shopDetails.shopId])

  useEffect(() => {
    Auth.currentAuthenticatedUser().then((res) => {
      dispatch({
        type: "IS_LOGGEDIN",
        payload: true,
      });
    });
    fetchShopType();
  }, []);

  var fetchShopType = async () => {
    var res = await fetch(config.fieldsArray);
    res = await res.json();
    setShopTypeArray(res.shopCategory);
  };

  const confirmLogin = async () => {
    const regExp = /[0-9][^a-z][^A-Z]\d/g;
    if (!regExp.test(otp)) return alert("Enter valid otp");
    if (otp === "" || otp.length < otpLength) return alert("Enter valid otp");
    setConfirmLoading(true);
    Auth.sendCustomChallengeAnswer(user, otp)
      .then(async (res) => {
        if (res.signInUserSession === null) {
          setConfirmLoading(false);
          return alert("The OTP that you have entered is invalid");
        }
        if (from === "login") {
          setConfirmLoading(true);
          getShopDetails(res)
            .then((shopData) => {
              requestPushNotification(shopData);
            })
            .catch((err) => {
              console.log(err);
            });
        } else {
          createNewUser(res);
        }
      })
      .catch((err) => {
        setConfirmLoading(false);
        setUserSignUp(true);
        console.log("Error", err);
        alert("Error", err);
      });
  };
  const resendOtp = () => {
    setResendOtpFlag(true);
    verifyNumber();
  };

  const createNewUser = async (res) => {
    var dbRes = await fetch(
      `${config.newApiGateway}/outlet/createShopProfile`,
      {
        method: "POST",
        headers: {
          "x-api-key": `${config.newApiKey}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          userId: res.attributes.sub,
          referralCode: res.attributes["custom:referralCode"],
          shopAddress: res.attributes["custom:userAddress"],
          shopName: res.attributes["custom:shopName"],
          shopType: res.attributes["custom:shopType"],
          shopPincode: res.attributes["custom:userPincode"],
          phoneNumber: res.attributes.phone_number,
          country: CountryJSON["+" + dialCode],
        }),
      },
    );
    dbRes = await dbRes.json();
    if (dbRes.code === "SUCCESS") {
      getShopDetails(res);
    } else {
      setConfirmLoading(false);
    }
  };

  const getShopDetailsApi = async (id) => {
    var shopDetailsRes = await fetch(
      `${config.newApiGateway}/customer/createCustomerandgetCustomer`,
      {
        method: "POST",
        body: JSON.stringify({
          shopId: id,
          action: "getShopDetails",
        }),
        headers: {
          "x-api-key": `${config.newApiKey}`,
          "Content-Type": "application/json",
        },
      },
    );
    shopDetailsRes = await shopDetailsRes.json();
    return shopDetailsRes.Items[0];
  };

  const validateLogin = (shopDetails) => {
    if (
      Math.ceil(
        (new Date(shopDetails.billingExpiryDate) - new Date()) /
          (1000 * 60 * 60 * 24),
      ) < 0
    ) {
      setLoading(false);
      setOtpInput(false);
      setPhoneNumber("");
      setConfirmLoading(false);
      setOtp("");
      alert("Billing Package Expired.");
      Auth.signOut().then(() => {
        dispatch({
          type: "IS_LOGGEDIN",
          payload: false,
        });
      });
      return;
    }
    dispatch({
      type: "SET_SHOP_PROFILE",
      payload: shopDetails,
    });
    dispatch({
      type: "IS_LOGGEDIN",
      payload: true,
    });

    props.history.push("/billing");
  };

  const fetchOutlets = async (shopId) => {
    try {
      var res = await fetch(`${config.newApiGateway}/outlet/getOutlet`, {
        method: "post",
        headers: {
          "x-api-key": `${config.newApiKey}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          type: "fetch",
          shopId: shopId,
        }),
      });
      res = await res.json();
      if (res.code === "ERROR") {
        return alert(res.message);
      }
      setOutletList(res.data);
      dispatch({
        type: "SET_OUTLETS",
        payload: res.data,
      });
      return res.data;
    } catch (err) {
      console.log("Err", err);
    }
  };

  const getShopDetails = async (res) => {
    try {
      var shopDetails = {};
      if (
        res.attributes["custom:userType"] &&
        res.attributes["custom:userType"] === "Employee"
      ) {
        let employeeShopDetails = await getShopDetailsApi(res.attributes.sub);
        let ownerShopDetails = await getShopDetailsApi(
          res.attributes["custom:ownerShopId"],
        );
        let outLets = await fetchOutlets(res.attributes["custom:ownerShopId"]);
        const outletObj = outLets?.find(
          (i) => i.userPhoneNumber === employeeShopDetails.userPhoneNumber,
        );
        // Outlet
        if (outletObj) {
          let outLetsShopDetails = await getShopDetailsApi(outletObj.userId);

          shopDetails = {
            ...ownerShopDetails,
            settings: outletObj.settings,
            taxMaster: outletObj.taxMaster,
            categoryList: outletObj.categoryList,
            ownerShopId: outletObj.ownerShopId,
            userId: outletObj.userId,
            // empId: employeeShopDetails.userId,
            userName: outletObj.userName,
            userPhoneNumber: outletObj.userPhoneNumber,
            shopPhoneNumber: ownerShopDetails.userPhoneNumber,
            userAddress: ownerShopDetails.shopAddress,
            shopAddress: outLetsShopDetails.shopAddress,
            userId10Digit: outletObj.userPhoneNumber,
            userType: outletObj.userType,
            userPincode: outletObj.userPincode,
            outletArea: outletObj.outletArea,
            customTaxType: outletObj.customTaxType,
            outletState: outletObj.outletState,
          };

          dispatch({
            type: "SET_SETTINGS",
            payload: outLetsShopDetails.settings,
          });
        } else {
          // Employee
          if (employeeShopDetails.unifiedAccess?.pos) {
            setAccess(employeeShopDetails.unifiedAccess.pos);
          }
          shopDetails = {
            ...ownerShopDetails,
            ...employeeShopDetails,
            ownerShopId: employeeShopDetails.ownerShopId,
            userId: employeeShopDetails.userId,
            employeeName: employeeShopDetails.userName,
            websiteContactPhoneNumber:
              ownerShopDetails.websiteContactPhoneNumber,
            userPhoneNumber: employeeShopDetails.userPhoneNumber,
            shopPhoneNumber: ownerShopDetails.userPhoneNumber,
          };
          dispatch({
            type: "SET_SETTINGS",
            payload: ownerShopDetails.settings,
          });
        }
        validateLogin(shopDetails);
        return shopDetails;
      } else {
        // Owner
        let ownerShopDetails = await getShopDetailsApi(res.attributes.sub);
        shopDetails = {
          ...ownerShopDetails,
        };
        console.log("ownerShopDetails", res.attributes.sub, ownerShopDetails);
        dispatch({
          type: "SET_SETTINGS",
          payload: ownerShopDetails.settings,
        });
        validateLogin(shopDetails);
        return shopDetails;
      }
    } catch (err) {
      console.log("err", err);
      setConfirmLoading(false);
      alert("Something went wrong. Please try again");
      setUserSignUp(false);
      Auth.signOut().then(() => {
        dispatch({
          type: "IS_LOGGEDIN",
          payload: false,
        });
      });
    }
  };
  const createUser = async () => {
    const validate = postcodeValidator(shopPincode, countryCode.toUpperCase());
    const validatePhoneNumber = countryData?.format?.split(" ").join("");
    if (!phoneNumber) {
      return alert("Please enter phone number");
    }
    if (!(validatePhoneNumber.length === `+${phoneNumber}`?.length)) {
      return alert("Please Enter valid Phone Number");
    }
    if (shopName === "") return alert("Please enter shopname");
    if (shopAddress === "") return alert("Please enter shop address");
    if (shopPincode === "") return alert("Please enter pincode");
    if (!validate && countryCode.toUpperCase() !== "AE")
      return alert("Please enter valid pincode");
    if (shopType === "Select a Shop type")
      return alert("Please select your shoptype");
    // const token = captchaRef.current.getValue();
    // let verifyBot = false;
    // if (!token) {
    //   return alert("You must confirm you are not a robot");
    // } else {
    //   const response = await verifyToken(token);
    //   verifyBot = response.success;
    // }
    // if (verifyBot) {
    setLoading(true);
    const id = uuidv4();
    var createUser = {
      username: "+" + phoneNumber,
      password: id,
      attributes: {
        "custom:shopName": shopName,
        "custom:shopType": shopType,
        "custom:userPincode": shopPincode,
        "custom:userAddress": shopAddress,
        "custom:referralCode": referralCodeGen(),
        "custom:campaign": "NA",
      },
    };
    console.log("createUser", createUser);
    await Auth.signUp(createUser)
      .then((res) => {
        loginProcess();
      })
      .catch((err) => {
        if (err.code === "UsernameExistsException") {
          alert("Account already exist. Please login.");
          setConfirmLoading(false);
          setUserSignUp(false);
          setLoading(false);
          setFrom("login");
          return;
        }
        setConfirmLoading(false);
        setUserSignUp(false);
        setLoading(false);
      });
    // } else {
    //   return alert("Signup failed, Reload and try again!");
    // }
  };

  const referralCodeGen = () => {
    let text = "";
    let possible =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    for (var i = 0; i < 6; i++) {
      text += possible.charAt(Math.floor(Math.random() * possible.length));
    }
    return text;
  };

  const fetchTermaAndCondition = async () => {
    try {
      let data = await fetch(config.termsAndConditions);
      let jsonData = await data.json();
      setTandC(jsonData.terms);
      setTandCModal(true);
    } catch (err) {
      console.log(err);
    }
  };

  const changeUserState = (type) => {
    window.localStorage.setItem("LOGIN_USERTYPE", type);
    setUserType(type);
    dispatch({
      type: "SET_USERTYPE",
      payload: type,
    });
  };

  const verifyToken = async (token) => {
    const response = await fetch(
      `${config.newApiGateway}/tools/verifyCaptcha`,
      {
        method: "POST",
        headers: {
          "x-api-key": `${config.newApiKey}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          token: token,
        }),
      },
    );
    const data = await response.json();
    return data;
  };

  useEffect(() => {
    const listener = (event) => {
      if (event.code === "Enter" || event.code === "NumpadEnter") {
        event.preventDefault();
        if (userSignUp) {
          createUser();
        } else if (!otpInput) {
          verifyNumber();
        } else if (otpInput) {
          confirmLogin();
        }
      }
    };
    document.addEventListener("keydown", listener);
    return () => {
      document.removeEventListener("keydown", listener);
    };
  }, [_phoneNumber, otpInput, userSignUp, otp]);

  return (
    <div className="login-wrapper">
      {!userSignUp ? (
        <div className="card-wrapper">
          <div className="login-image">
            <img src={LoginImg} alt="logo" />
          </div>
          <div className="login-image-mobile">
            <img src={LoginImgMobile} alt="logo" />
          </div>
          <div className="login-input">
            <div
              style={{
                width: 380,
                paddingLeft: "5rem",
              }}
            >
              <div className="login-text">
                <h3>
                  {from === "login"
                    ? userType === "owner"
                      ? "ADMIN LOGIN"
                      : "USER / OUTLET LOGIN"
                    : "SIGN UP"}
                </h3>
              </div>
              <br />

              {otpInput ? (
                <div
                  style={{
                    textAlign: "left",
                  }}
                  className="otp-input-label"
                >
                  <label>OTP</label>
                  <div className="login-input-box">
                    <input
                      className="otp-input"
                      placeholder="Enter the OTP"
                      value={otp}
                      onChange={(e) => setOtp(e.target.value)}
                      maxLength={otpLength}
                    />
                  </div>
                  <div
                    style={{
                      marginTop: "10px",
                    }}
                    className="login-buttons"
                  >
                    <div>
                      <Button
                        onClick={confirmLogin}
                        disabled={confirmLoading}
                        type="submit"
                        style={{
                          width: "100%",
                        }}
                      >
                        {confirmLoading ? (
                          <>
                            {/* <span className="sr-only">Logging in...</span>{" "} */}
                            <Spinner
                              as="span"
                              animation="border"
                              size="sm"
                              role="status"
                              aria-hidden="true"
                            />
                          </>
                        ) : (
                          <>{from === "login" ? "Login" : "Sign Up"}</>
                        )}
                      </Button>
                    </div>
                  </div>
                  <div className="terms-and-condition-text">
                    <p> Did not get your OTP yet,</p>
                    <p
                      style={{ color: "#ef4667", cursor: "pointer" }}
                      onClick={() => {
                        resendOtp();
                      }}
                    >
                      {" "}
                      Resend.
                    </p>
                  </div>
                </div>
              ) : (
                <div
                  style={{
                    width: "100%",
                  }}
                >
                  <Form>
                    <Form.Item
                      style={{
                        marginBottom: 8,
                      }}
                      label="Mobile Number"
                      labelCol={{ span: 24 }}
                    >
                      <div className="phoneNumberWrapper">
                        <PhoneInput
                          specialLabel=""
                          onlyCountries={["in", "ph", "ae", "us", "lk"]}
                          country={
                            ["in", "ph", "ae", "us"].includes(defaultDialCode)
                              ? defaultDialCode
                              : "in"
                          }
                          countryCodeEditable={false}
                          containerStyle={{
                            width: "100%",
                          }}
                          inputStyle={{
                            width: "100%",
                            height: 34,
                          }}
                          masks={{
                            ph: "... ... ....",
                            in: "... ... ....",
                            us: "... ... ....",
                            ae: ".. ... ....",
                            lk: ".... ......",
                          }}
                          placeholder="Enter your mobile number"
                          value={phoneNumber}
                          onChange={(v, country) => {
                            setDialCode(country.dialCode);
                            setPhoneNumber(v);
                            setCountryCode(country.countryCode);
                            setCountryData(country);
                          }}
                        />
                      </div>
                    </Form.Item>
                    {/* <ReCAPTCHA sitekey={config.captcha} ref={captchaRef} /> */}
                  </Form>
                  {!otpInput && (
                    <div
                      style={{
                        textAlign: "center",
                      }}
                    >
                      {" "}
                      <div
                        style={{
                          textAlign: "right",
                        }}
                      >
                        <button
                          onClick={verifyNumber}
                          disabled={loading}
                          type="submit"
                          id="getOtp"
                          style={{
                            margin: 0,
                            height: 40,
                            borderRadius: 4,
                            color: "#fff",
                            padding: "0 1rem",
                            width: "100%",
                            background: colorPrimary,
                            border: 0,
                            marginTop: 8,
                          }}
                        >
                          {loading ? (
                            <>
                              <span className="sr-only">Get OTP </span>{" "}
                              <Spinner
                                as="span"
                                animation="border"
                                size="sm"
                                role="status"
                                aria-hidden="true"
                              />
                            </>
                          ) : (
                            <>Get OTP</>
                          )}
                        </button>
                      </div>
                      {userType === "owner" && (
                        <>
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "space-between",
                              marginTop: 4,
                              marginBottom: 4,
                            }}
                          >
                            <div>Don't have an account. </div>
                            <div>
                              <span
                                style={{
                                  color: "blue",
                                  textDecoration: "underline",
                                  cursor: "pointer",
                                }}
                                onClick={() => {
                                  setUserSignUp(true);
                                  setFrom("signup");
                                }}
                              >
                                Sign Up
                              </span>
                              {userType === "owner" && (
                                <span>
                                  <span> or </span>
                                  <span
                                    style={{
                                      color: "blue",
                                      textDecoration: "underline",
                                      cursor: "pointer",
                                    }}
                                    onClick={() => changeUserState("employee")}
                                  >
                                    User login
                                  </span>
                                </span>
                              )}
                            </div>
                          </div>
                        </>
                      )}
                      {userType === "employee" && (
                        <p
                          style={{
                            color: "blue",
                            textDecoration: "underline",
                            cursor: "pointer",
                          }}
                          onClick={() => changeUserState("owner")}
                        >
                          Admin login
                        </p>
                      )}
                    </div>
                  )}
                </div>
                // <div
                //   style={{
                //     marginLeft: "6rem",
                //     textAlign: "left",
                //     width: "350px",
                //   }}
                // >
                //   <div className="phoneInputWrapper">
                //     <PhoneInput
                //       onlyCountries={["in", "ph", "ae", "us"]}
                //       country={
                //         ["in", "ph", "ae", "us"].includes(defaultDialCode)
                //           ? defaultDialCode
                //           : "in"
                //       }
                //       containerStyle={{
                //         width: "100%",
                //       }}
                //       inputStyle={{
                //         width: "100%",
                //       }}
                //       masks={{
                //         ph: "... ... ....",
                //         in: "... ... ....",
                //         us: "... ... ....",
                //       }}
                //       placeholder="Enter your mobile number"
                //       value={phoneNumber}
                //       onChange={(v, country) => {
                //         setDialCode(country.dialCode);
                //         setPhoneNumber(v);
                //         setCountryCode(country.countryCode);
                //         setCountryData(country);
                //       }}
                //     />
                //     <label>Mobile Number</label>
                //   </div>
                //   <div
                //     style={{
                //       fontSize: 13,
                //       display: "flex",
                //       gap: 6,
                //       marginTop: 4,
                //     }}
                //   >
                //     <p>By Signing up, you agree to the </p>
                //     <p
                //       style={{ color: "blue", cursor: "pointer" }}
                //       onClick={() => fetchTermaAndCondition()}
                //     >
                //       terms and conditions.
                //     </p>
                //   </div>

                // </div>
              )}
            </div>
          </div>
        </div>
      ) : (
        <div className="card-wrapper">
          <div className="login-image">
            <img src={LoginImg} alt="loginImage" />
          </div>
          <div className="login-input">
            <div className="shop-details-text">
              <Typography.Text>Welcome!</Typography.Text>
              <Typography.Title level={3}>Gets Started!</Typography.Title>
            </div>

            {/*  */}

            <div className="login-input-shop-details">
              <div className="login-input-shop-details-input">
                <div style={{ display: "flex" }}>
                  <Typography.Text>Mobile Number</Typography.Text>
                  <h5>*</h5>
                </div>
                <PhoneInput
                  specialLabel=""
                  onlyCountries={["in", "ph", "ae", "us", "lk"]}
                  country={
                    ["in", "ph", "ae", "us"].includes(defaultDialCode)
                      ? defaultDialCode
                      : "in"
                  }
                  masks={{
                    ph: "... ... ....",
                    in: "... ... ....",
                    us: "... ... ....",
                    ae: ".. ... ....",
                    lk: ".... ......",
                  }}
                  placeholder="Enter your mobile number"
                  value={phoneNumber}
                  inputStyle={{
                    marginLeft: 0,
                    borderColor: "#000",
                    width: "100%",
                    height: 34,
                  }}
                  containerStyle={{
                    marginLeft: "15%",
                    width: "70%",
                  }}
                  onChange={(v, country) => {
                    setPhoneNumber(v);
                    setDialCode(country.dialCode);
                    setCountryCode(country.countryCode);
                    setCountryData(country);
                  }}
                />
              </div>
              <div className="login-input-shop-details-input">
                <div style={{ display: "flex" }}>
                  <Typography.Text>Business name</Typography.Text>
                  <h5>*</h5>
                </div>
                <input
                  type="text"
                  placeholder="Enter your business name"
                  value={shopName}
                  onChange={(e) => setShopName(e.target.value)}
                />
              </div>
              <div className="login-input-shop-details-input">
                <div style={{ display: "flex" }}>
                  <Typography.Text>Shop Address</Typography.Text>
                  <h5>*</h5>
                </div>
                <input
                  type="text"
                  placeholder="Enter shop address"
                  value={shopAddress}
                  onChange={(e) => setShopAddress(e.target.value)}
                />
              </div>
              <div className="login-input-shop-details-input">
                <div style={{ display: "flex" }}>
                  <Typography.Text>Shop Pincode</Typography.Text>
                  {countryCode !== "ae" && <h5>*</h5>}
                </div>
                <input
                  type="number"
                  placeholder="Enter shop pincode"
                  value={shopPincode}
                  onChange={(e) => setShopPincode(e.target.value)}
                  // disabled
                />
              </div>
              <div className="login-input-shop-details-input">
                <div style={{ display: "flex" }}>
                  <Typography.Text>Shop Type</Typography.Text>
                  <h5>*</h5>
                </div>
                <select
                  onChange={(e) => setShopType(e.target.value)}
                  value={shopType}
                >
                  <option value="" disabled>
                    Select Shop Type
                  </option>
                  {shopTypeArray.map((data) => (
                    <option key={data} value={data}>
                      {data}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            <br />

            <div className="update-profile-btn">
              <div
                style={{
                  marginLeft: "5rem",
                  textAlign: "left",
                }}
              >
                {/* <ReCAPTCHA sitekey={config.captcha} ref={captchaRef} /> */}
              </div>
              <Button onClick={createUser} disabled={loading}>
                {loading ? (
                  <>
                    <span className="sr-only">Sign Up</span>{" "}
                    <Spinner
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                    />
                  </>
                ) : (
                  <>Sign Up</>
                )}
              </Button>
              <div
                style={{
                  fontSize: 13,
                  display: "flex",
                  gap: 6,
                  marginTop: 4,
                  marginLeft: "15%",
                }}
              >
                <p>By Signing up, you agree to the </p>
                <p
                  style={{ color: "blue", cursor: "pointer" }}
                  onClick={() => fetchTermaAndCondition()}
                >
                  terms and conditions.
                </p>
              </div>
            </div>
            {!otpInput && (
              <div
                style={{
                  marginTop: 10,
                }}
              >
                <p>
                  Already have an account.
                  <span
                    style={{
                      color: "blue",
                      textDecoration: "underline",
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      setUserSignUp(false);
                      setFrom("login");
                    }}
                  >
                    Sign In
                  </span>
                </p>
              </div>
            )}
          </div>
        </div>
      )}
      <Modal show={tAndCModal} dialogClassName="termsAndConditionModal">
        <Modal.Body>
          <div className="termsHeader">
            <h1>Terms of Use Agreement</h1>
          </div>
          <div
            className="termsBody"
            style={{ margin: "5px", textAlign: "justify" }}
          >
            {tAndC.map((data) => (
              <>
                {data.heading !== "" && (
                  <div>
                    <h4>{data.heading}</h4>
                  </div>
                )}
                <p>{data.content}</p>
              </>
            ))}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={() => setTandCModal(false)}>Close</Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default withRouter(Login);
